import React, {FC, useEffect, useRef} from 'react';
import { Setting } from '../App';
import classes from '../asset/css/main.module.css';
import { Complete } from '../components/Complete';

export const PaymentMethodComplete: FC<{ setting: Setting }> = ({ setting }) => {
  const root = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setting.resize(root.current?.clientHeight ?? 0);
  }, [setting, root.current?.clientHeight]);

  return (
    <>
      <div className={classes.mypage_subsc_container} ref={root}>
        <Complete
          title="クレジットカード変更受付完了"
          body="ご登録頂いているメールアドレスへ決済方法変更用のURLを送付いたしました。<br/>お手数ですが、そちらからご変更ください。"
          backTo="/"
          isParent={false}
        />
      </div>
    </>
  );
};
